<template>
  <div style="margin: 10px 40px 0px">
    <el-form style="margin-right: 30px" :model="addUserForm" :rules="addUserRules" ref="addUserForm" label-width="110px" class="demo-ruleForm">
      <el-row>
        <el-col :span="12">
          <el-form-item label="工号" prop="jobnum">
            <el-input v-model="addUserForm.jobnum" placeholder="请输入工号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="人员名称" prop="name">
            <el-input v-model="addUserForm.name" placeholder="请输入人员名称"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系方式" prop="phone">
            <el-input type="number" v-model="addUserForm.phone" placeholder="请输入联系方式"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属组织" prop="orgid">
            <el-cascader v-fixZoom
              style="width: 100%"
              :options="orgOptions"
              v-model="addUserForm.orgid"
              :filterable="true"
              placeholder="请选择所属组织"
              :props="{ checkStrictly: true, value: 'id', label: 'name', children: 'child', emitPath: false}"
              ref="orgOptions">
            </el-cascader>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="地址" prop="address">
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入地址"
          v-model="addUserForm.address"
          @blur="testAddress()">
        </el-input>
      </el-form-item>
      <el-form-item label="小程序账号" prop="">
        <el-radio-group v-model="addUserForm.is_open_applet">
          <el-radio :label="0">不开通</el-radio>
          <el-radio :label="1">开通</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否新建账号">
        <el-button size="mini" icon="el-icon-circle-plus-outline" type="primary" plain @click="showAddUser()">添加</el-button>
      </el-form-item>
      <el-row v-if="addAccForm.username !== ''">
        <el-col :span="12">
          <el-form-item label="账号用户名：">
            <span>{{addAccForm.username}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="权限：">
            <span>{{getRoleName()}}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div>
      <el-row style="margin: 0 100px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAdd()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitAddUser('addUserForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div style="height: 20px"></div>
    <el-dialog
      width="500px"
      :visible.sync="addShow"
      v-if="addShow"
      center
      append-to-body
      class="all-open">
      <div class="title-top-alarm">
        <div>
          <span>新建账号</span>
        </div>
        <div class="line-title"></div>
      </div>
      <account-add :accountAddRow="addRow" v-model="addShow"></account-add>
    </el-dialog>
  </div>
</template>

<script>
import {addorgperson} from '../../../api/orguser'
import {adduser} from '../../../api/account'
import accountAdd from './accountAdd'
export default {
  name: 'userAdd',
  components: {accountAdd},
  model: {
    prop: 'addShow',
    event: 'change'
  },
  props: {
    userAddRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      orgOptions: [],
      addUserForm: {
        id: 0,
        name: '',
        phone: '',
        address: '',
        jobnum: '',
        orgid: '',
        is_open_applet: 0
      },
      addUserRules: {
        jobnum: [
          { required: true, message: '请输入人员工号', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入人员名称', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
        orgid: [
          { required: true, message: '请选择所属组织', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ]
      },
      addShow: false,
      addRow: {
        persons: [],
        supplierorgpersons: [],
        isAddUser: true
      },
      addAccForm: {
        id: 0,
        username: '',
        password: '',
        role: '',
        spid: '',
        supplier_pid: 0,
        moduletag: [],
        customerservicetag: ''
      },
      isAdd: false // 是否新建账号
    }
  },
  created () {
    this.golobleObject.addAccUser = this.sendUser
    this.orgOptions = this.userAddRow.orgTree
  },
  mounted () {
  },
  methods: {
    getRoleName () {
      let row = this.addAccForm
      if (row.role === 'superadmin') {
        return '超级管理者'
      } else if (row.role === 'admin') {
        return '管理者'
      } else if (row.role === 'op') {
        return '运营'
      } else if (row.role === 'csd') {
        return '客服'
      } else if (row.role === 'guest') {
        return '访客'
      } else if (row.role === 'company') {
        return '服务商'
      } else if (row.role === 'sv') {
        return '监管'
      } else {
        return row.role
      }
    },
    testAddress () {
      this.addUserForm.address = this.addUserForm.address.replace(/[\r\n]/g, '')
    },
    sendUser (obj) {
      console.log(obj)
      this.isAdd = true
      this.addAccForm = obj
    },
    showAddUser () {
      this.addShow = true
    },
    submitAddUser (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addorgperson(this.addUserForm).then(res => {
            this.addAccForm.spid = res.data.spid
            if (this.isAdd) {
              this.getCommitUser()
            } else {
              this.golobleObject.updateTableUser(this.isAdd)
              this.$emit('change', false)
            }
          }).catch(() => {
            this.$notify.error({
              title: '失败',
              message: '新建平台人员失败'
            })
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getCommitUser () {
      let moduletag = ''
      if (this.addAccForm.moduletag.length === 2) {
        moduletag = 3
      } else if (this.addAccForm.moduletag[0] === '居家') {
        moduletag = 1
      } else if (this.addAccForm.moduletag[0] === '机构') {
        moduletag = 2
      }
      let customerservicetag = ''
      if (this.addAccForm.customerservicetag === '') {
        customerservicetag = 0
      } else {
        customerservicetag = parseInt(this.addAccForm.customerservicetag)
      }
      let data = {
        id: this.addAccForm.id,
        username: this.addAccForm.username,
        password: this.addAccForm.password,
        role: this.addAccForm.role,
        spid: this.addAccForm.spid,
        supplier_pid: this.addAccForm.supplier_pid,
        moduletag: moduletag,
        customerservicetag: customerservicetag
      }
      adduser(data).then(res => {
        this.$notify({
          title: '成功',
          message: '成功新建平台人员',
          type: 'success',
          duration: 2000
        })
        this.golobleObject.updateTableUser(this.isAdd)
        this.$emit('change', false)
      }).catch(() => {})
    },
    closeAdd () {
      this.$emit('change', false)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/userAdd.vue